var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTopUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.461,
    height: 45,
    viewBox: "0 0 48.461 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TOP_UP",
    "data-name": "TOP UP",
    transform: "translate(-114.8 -61.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M125.062,296.8a10.262,10.262,0,1,0,10.262,10.262A10.263,10.263,0,0,0,125.062,296.8Zm5.986,11.973h-4.276v4.276a.855.855,0,0,1-.855.855h-1.71a.855.855,0,0,1-.855-.855v-4.276h-4.276a.855.855,0,0,1-.855-.855v-1.711a.855.855,0,0,1,.855-.855h4.276v-4.276a.855.855,0,0,1,.855-.855h1.71a.855.855,0,0,1,.855.855v4.276h4.276a.855.855,0,0,1,.855.855v1.711A.855.855,0,0,1,131.049,308.773Z",
    transform: "translate(0 -210.729)",
    fill: "#ce1952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M488.676,196h5.987v8.552h-5.987a4.276,4.276,0,1,1,0-8.552Z",
    transform: "translate(-331.402 -120.519)",
    fill: "#ce1952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M223.617,87.253v6.842a3.445,3.445,0,0,1-3.468,3.421H199.22A13.778,13.778,0,0,0,182,82.57V63.307a1.722,1.722,0,0,1,1.734-1.711h36.417a3.445,3.445,0,0,1,3.468,3.421v6.842h-6.07a7.7,7.7,0,1,0,0,15.394Z",
    transform: "translate(-60.357)",
    fill: "#ce1952"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTopUp);
export default __webpack_public_path__ + "static/media/ic-topUp.2e935ab6.svg";
export { ForwardRef as ReactComponent };